import { createEffect, createSignal, Show } from "solid-js";
import { tooltip } from "../../app/tooltip";
import { MovePattern } from "./MovePattern";

/**
 * Floating tooltip that follows the cursor but never spills off-screen: it's
 * measured after render and flipped to the other side of the cursor (and clamped
 * to the viewport) when it would overflow the right or bottom edge.
 */
export function Tooltip() {
  let el: HTMLDivElement | undefined;
  const [pos, setPos] = createSignal({ left: -9999, top: -9999 });

  createEffect(() => {
    const t = tooltip();
    if (!t || !el) return;
    const off = 16;
    const pad = 10;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const w = el.offsetWidth;
    const h = el.offsetHeight;

    let left = t.x + off;
    if (left + w + pad > vw) left = t.x - w - off; // flip to the cursor's left
    left = Math.max(pad, Math.min(left, vw - w - pad)); // clamp within the viewport

    let top = t.y + off;
    if (top + h + pad > vh) top = t.y - h - off; // flip above the cursor
    top = Math.max(pad, Math.min(top, vh - h - pad));

    setPos({ left, top });
  });

  return (
    <Show when={tooltip()}>
      {(t) => (
        <div
          ref={el}
          class="tooltip"
          classList={{ "tooltip--rich": !!t().type }}
          style={{ left: `${pos().left}px`, top: `${pos().top}px` }}
        >
          <Show when={t().type}>
            {(type) => (
              <div class="tt-pattern">
                <MovePattern type={type()} />
              </div>
            )}
          </Show>
          <div class="tt-text">{t().text}</div>
        </div>
      )}
    </Show>
  );
}
